RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _, scheduleEnums, moment, s) {

    'use strict';

    models.Schedule = Backbone.Model.extend({
        initialize: function (attrs) {
            const me = this;

            // Set local timezone offset if none provided
            if (!_.has(attrs, 'offset')) {
                me.set({
                    offset: (new Date()).getTimezoneOffset() / 60
                });
            }

            me.on('change:period', me.updateFirstRunAt);
            me.on('change:startOfWeek', me.updateFirstRunAt);
        },

        updateFirstRunAt: function () {
            const me = this;

            if (_.exists(me.get('startOfWeek'))) {
                const defaultDate = me.getDeliveryDateOptions()[0];
                me.set('firstRunAt', defaultDate.format());
            }
        },

        isBiweekly: function () {
            const me = this;
            return me.get('period') === scheduleEnums.period.BIWEEK;
        },

        /*
         * Get valid durations for the export
         */
        getValidPeriods: function () {
            const periods = _.values(RivalIQ.enums.schedule.period);

            const restricted = RivalIQ.state.account.timePeriodRestricted();

            return _.map(periods, function (period, i) {
                return {
                    id: period,
                    disabled: restricted && i > 0
                };
            });
        },

        /*
         * Get valid durations for the selected period
         */
        getValidDurations: function () {
            const me = this;
            const period = me.get('period');

            const durations = [];
            _.each(scheduleEnums.durations, function (duration) {
                if (_.includes(duration.types, period)) {
                    durations.push(_.extend({
                        disabled: !RivalIQ.state.account.durationSupported(duration)
                    }, duration));
                }
            });

            return durations;
        },

        usesWeekBoundries: function () {
            const me = this;
            return _.includes([scheduleEnums.period.WEEK, scheduleEnums.period.BIWEEK], me.get('period'));
        },

        getDeliveryDateOptions: function () {
            const me = this;
            const startOfWeek = me.get('startOfWeek');
            if (_.exists(startOfWeek)) {
                const dayIndex = scheduleEnums.days.indexOf(startOfWeek);
                // Find the next date of that day and the one the week after
                // Intentionally not in UTC
                return [moment().day(7 + dayIndex), moment().day(14 + dayIndex)];
            }

            return [];
        },

        getSentence: function () {
            const me = this;
            switch (me.get('period')) {
                case scheduleEnums.period.DAY:
                    return '<strong>every day</strong>';
                case scheduleEnums.period.WEEK:
                    return ['<strong>every week</strong> on ',
                        '<strong>',
                        `${s.titleize(me.get('startOfWeek'))}s`,
                        '</strong>'].join(' ');
                case scheduleEnums.period.BIWEEK: {
                    const startDate = (me.get('firstRunAt') ? moment(me.get('firstRunAt')).format('ddd, MMMM Do') : '');
                    return [
                        '<strong>every other week</strong> on ',
                        '<strong>',
                        `${s.titleize(me.get('startOfWeek'))}s`,
                        '</strong>',
                        'starting on',
                        '<strong>',
                        startDate,
                        '</strong>'
                    ].join(' ');
                }
                case scheduleEnums.period.MONTH:
                    return 'at the start of <strong>every month</strong>';
                default:
                    throw new Error(`unknown time period ${me.get('period')}`);
            }
        },

        validate: function (attrs) {
            const errors = [];

            if (!_.exists(attrs.period)) {
                errors.push(['period', 'Please select a report period']);
            }

            if (_.includes([scheduleEnums.period.WEEK, scheduleEnums.period.BIWEEK], attrs.period) && !_.exists(attrs.startOfWeek)) {
                errors.push(['startOfWeek', 'Please select the day your week starts on']);
            }

            if (attrs.period === scheduleEnums.period.BIWEEK && !_.exists(attrs.firstRunAt)) {
                errors.push(['firstRunAt', 'Please select a date we should deliver the first report on']);
            }

            if (!errors.length) {
                return null;
            }

            return errors;
        }
    });
}, RivalIQ.enums.schedule, window.moment, window.s);
